import {all} from "redux-saga/effects";
import authSagas from "./Auth";
import quotaSagas from "./Quota";
import crisisSagas from "./Crisis";
import buzzSagas from "./Buzz";
import campaignSagas from "./Campaign";
import rateCardSagas from "./RateCard";
import rateCardValueSagas from "./RateCardValue";
import peopleLevelInBrandSagas from "./PeopleLevelInBrand";
import peopleLevelInCampaignSagas from "./PeopleLevelInCampaign";
import freqSagas from "./Freq";
import categorySagas from "./Category";
import industrySagas from "./Industry";
import roleSagas from "./Role";
import sampleSizeSagas from "./SampleSize"
import analysisLevelGuideSagas from "./AnalysisLevelGuide";
import logSagas from "./Log";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    quotaSagas(),
    crisisSagas(),
    buzzSagas(),
    campaignSagas(),
    rateCardSagas(),
    rateCardValueSagas(),
    peopleLevelInBrandSagas(),
    peopleLevelInCampaignSagas(),
    freqSagas(),
    categorySagas(),
    industrySagas(),
    roleSagas(),
    sampleSizeSagas(),
    analysisLevelGuideSagas(),
    logSagas(),
  ]);
}
